import Navbarsec from "./Navbarsec";

export default function Deals() {
    return(
        <div>
            <Navbarsec />
            <div className=" flex items-center justify-center bg-white dark:bg-gray-900">
      <div className="py-8 px-4 mx-auto max-w-screen-md text-center lg:py-16 lg:px-12">
        <img src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExczQ5OXp0aTd4d3l0Z2M0aTYwaXYxcGp5c284cGM5MHI5bGdubW43ZiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/7N34Raoi8VtdGvPTcP/giphy.gif" alt="Deals Icon" className="mx-auto mb-4 w-24 h-24 text-gray-400" />
        <h1 className="mb-4 text-4xl font-bold tracking-tight leading-none text-gray-900 lg:mb-6 md:text-5xl xl:text-6xl dark:text-white">Finding Deals for you!</h1>
        <p className="font-light text-gray-500 md:text-lg xl:text-xl dark:text-gray-400">Exciting deals and offers are on the way. Check back soon!</p>
      </div>
    </div>
        </div>
    );
}
